import { IonPage, IonRouterOutlet, IonSplitPane,IonPopover,IonContent } from '@ionic/react';
import { useEffect } from 'react';
import { Redirect, Route, RouteComponentProps, withRouter } from 'react-router-dom';
import DonateToOrgPms from './donations_and_credit/transactions/DonateToOrgPms';
import DonateToOrgPmsV2 from './donations_and_credit/transactions/DonateToOrgPmsV2';
import Menu from '../components/Menu';
import { Account, User } from '../models/data';
import DashbordHome from './DashbordHome';
import About from './documents/About';
import Faq from './documents/Faq';
import Credit from './donations_and_credit/Credit';
import DirectDonate from './donations_and_credit/DirectDonate';
import Donate from './donations_and_credit/Donate';
import DonateFundraiseOnlineProcess from './donations_and_credit/DonateFundraiseOnlineProcess';
import DonateToFundraiserStart from './donations_and_credit/DonateFundraiser';
import DonateHome from './donations_and_credit/DonateHome';
import DonateOnline from './donations_and_credit/DonateOnline';
import DonateOnlineV2 from './donations_and_credit/DonateOnlineV2';
import History from './donations_and_credit/History';
import TransactionFailure from './donations_and_credit/TransactionFailure';
import TransactionSuccess from './donations_and_credit/TransactionSuccess';
import AllFeeds from './feeds/AllFeeds';
import Feed from './feeds/Feed';
import FundraiseByUserList from './fundraise/FundraiseByUserList';
import FundraiseCreate from './fundraise/FundraiseCreate';
import FundraiserDetail from './fundraise/FundraiseDetail';
import FundraiseEdit from './fundraise/FundraiseEdit';
import FundraiseHome from './fundraise/FundraiseHome';
import Organizations from './organizations/Organizations';
import Orgdetail from './organizations/OrgDetail';
import Profile from './user/Profile';
import Security from './user/Security';
import DonateToOrgCrd from './donations_and_credit/transactions/DonateToOrgCrd';
import DonateToFundraiserCrd from './donations_and_credit/transactions/DonateToFundraiserCrd';
import DonateToFundraiserPms from './donations_and_credit/transactions/DonateToFundraiserPms';
import DonateGift from './donations_and_credit/transactions/DonateGift';
import GiftCardHome from './giftcards/giftcardshome';
import UpDateUserInfo from './authentication/UpdateUserInfo';

interface DashboardProps extends RouteComponentProps {
  user: User,
  account: Account,
  signIn: any,
  removeUser: any,
  lan: string,
  refresh:any
}

const Dashboard: React.FC<DashboardProps> = (props) => {
  useEffect(() => {
    props.signIn(true);
    return () => { };
  })

  const isUserInfoComplete = () => {
    if (props.user) {
      if (props.user.role === "customer" && props.user.dateOfBirth) {
        return true;
      }else if(props.user.role!=="customer"){
        return true;
      }else{
        return false
      }
    }
    return true; // no user
  }



  return (
    <IonPage className='pageContent'>
      {!isUserInfoComplete() && 
      <IonPopover alignment='end' side='end' reference='event' className='userInfoPopover'  backdropDismiss={false} isOpen={true}>
        <IonContent>
          <UpDateUserInfo refresh={props.refresh} user={props.user}></UpDateUserInfo>
        </IonContent>
      </IonPopover>
      }
      <IonSplitPane id="mainContent" contentId='main'>
        <Menu lan={props.lan} user={props.user} signIn={props.signIn} removeUser={props.removeUser} />
        <IonRouterOutlet id="main">

          <Route exact path={`${props.lan}/account`} >
            <Redirect to={`${props.lan}/account/start`}></Redirect>
          </Route>

          <Route path={`${props.lan}/account/start`} exact>
            <DashbordHome user={props.user} account={props.account} />
          </Route>

          <Route path={`${props.lan}/account/donate`/** */}>
            <DonateHome user={props.user} />
          </Route>
          <Route path={`${props.lan}/account/giftcard`/** */}>
            <GiftCardHome user={props.user} />
          </Route>
          <Route path={`${props.lan}/account/donate_start`}>
            <Donate user={props.user} />
          </Route>
          <Route path={`${props.lan}/account/donate_start/:name`} exact={true}>
            <Donate user={props.user} />
          </Route>
          <Route path={`${props.lan}/account/donate_direct_to_org`} >
            <DonateToOrgPms user={props.user} />
          </Route>
          <Route path={`${props.lan}/account/donate_direct_to_org_v2`} >
            <DonateToOrgPmsV2 user={props.user} />
          </Route>
          <Route path={`${props.lan}/account/donate_gift`} >
            <DonateGift user={props.user} />
          </Route>
          <Route path={`${props.lan}/account/with_credit_to_org`} >
            <DonateToOrgCrd user={props.user} />
          </Route>
          <Route path={`${props.lan}/account/with_credit_to_fundraiser`} >
            <DonateToFundraiserCrd user={props.user} />
          </Route>
          <Route path={`${props.lan}/account/direct_to_fundraiser`} >
            <DonateToFundraiserPms user={props.user} />
          
          </Route>
          <Route path={`${props.lan}/account/donate_process`} >
            <DonateOnline user={props.user} />
          </Route>
          <Route path={`${props.lan}/account/donate_process_v2`} >
            <DonateOnlineV2 user={props.user} />
          </Route>
          <Route path={`${props.lan}/account/about`}>
            <About />
          </Route>
          <Route path={`${props.lan}/account/History`}>
            <History user={props.user} />
          </Route>
          <Route path={`${props.lan}/account/credit`}>
            <Credit user={props.user} />
          </Route>
          <Route path={`${props.lan}/account/fundraise`}>
            <FundraiseHome user={props.user} />
          </Route>
          <Route path={`${props.lan}/account/userfundraisers`}>
            <FundraiseByUserList user={props.user} />
          </Route>
          <Route path={`${props.lan}/account/fundraisersbyuser`}>
            <FundraiseByUserList user={props.user} />
          </Route>
          <Route path={`${props.lan}/account/fundraisercreate`}>
            <FundraiseCreate user={props.user} />
          </Route>
          <Route path={`${props.lan}/account/fundraisers/:id`}>
            <FundraiserDetail user={props.user}/>
          </Route>
          <Route path={`${props.lan}/account/fundraisers/edit/:id`}>
            <FundraiseEdit  user={props.user}/>
          </Route>
          <Route path={`${props.lan}/account/profile`}>
            <Profile />
          </Route>
          <Route path={`${props.lan}/account/security`}>
            <Security />
          </Route>
          <Route path={`${props.lan}/account/directdonate`}>
            <DirectDonate />
          </Route>
          <Route path={`${props.lan}/account/charities`}>
            <Organizations />
          </Route>
          <Route path={`${props.lan}/account/charities/:id`}>
            <Orgdetail user={props.user} />
          </Route>
          <Route path={`${props.lan}/account/payment_success`}>
            <TransactionSuccess />
          </Route>
          <Route path={`${props.lan}/account/payment_failure`}>
            <TransactionFailure />
          </Route>
          <Route path={`${props.lan}/account/use_credit/:id`}>
            <DonateToFundraiserStart user={props.user} />
          </Route>
          <Route path={`${props.lan}/account/fundraiser_donate_online`}>
            <DonateFundraiseOnlineProcess user={props.user} />
          </Route>
          <Route path={`${props.lan}/account/feeds`} exact={true}>
            <AllFeeds />
          </Route>
          <Route path={`${props.lan}/account/feeds/:id`}>
            <Feed />
          </Route>
          <Route path={`${props.lan}/account/faq`}>
            <Faq user={props.user} />
          </Route>
        </IonRouterOutlet>
       
      </IonSplitPane>
      
    </IonPage>
  );
}

export default withRouter(Dashboard);
